import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { formLegacyDefaultV0Schema } from './default';
import { formLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Like button, the two variants diverge on the inner data shape — but only
 * on `position`: the default branch carries the simple per-device grid, the
 * zero branch requires the extended-position grid.
 */
const formLegacyEntityUnion = z.discriminatedUnion('type', [formLegacyDefaultV0Schema, formLegacyZeroV0Schema]);

export type LegacyFormDefault = z.infer<typeof formLegacyDefaultV0Schema>;
export type LegacyFormZero = z.infer<typeof formLegacyZeroV0Schema>;
export type LegacyFormWidget = LegacyFormDefault | LegacyFormZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant when
 * the widget is unified across apps. When a redesigned `default/v0` lands, this
 * switches to a versioned schema and the variants gain `up` migrations into it.
 */
export const LegacyFormWidgetEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: formLegacyEntityUnion }]);
